export default {
    props: {
        openOnClickRootMenuItems: {
            type: Boolean,
            kComposite: 'openOnClick.rootMenuItems'
        }, 
        openOnClickSubMenuItems: {
            type: Boolean,
            kComposite: 'openOnClick.subMenuItems'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/OpenOnClick.js